import { StandardEntity } from '@infodata-group/inf-commons';
import { VehicleDto } from '../interface/vehicle.dto';

export class Vehicle extends StandardEntity {
  public date: string;
  public brand: string;
  public model: string;
  public active: boolean;
  get stateFormater(): string {
    return this.active ? 'Actif' : 'Inactif';
  }
  public bbxId: string;

  constructor() {
    super();
  }

  public override serialize(): VehicleDto {
    return {
      id: this.id,
      date: this.date,
      brand: this.brand,
      model: this.model,
      active: this.active,
      bbxId: this.bbxId,
    };
  }
}
